import React, { useEffect, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import { EyeIcon } from '../../../utils/TableActionIcons';
import { viewFormEntriesTableColumns } from '../../../constants/FormCreationConstants';
import useFetchData from '../../../hooks/UseFetchData';
import { labModuleApi } from '../../../helpers/labModuleApi';
import CustomTable from '../../../shared/CustomTable';
import FormsResultsPreviewTable from '../general-form-entries/FormsResultsPreviewTable';
import { formatDateTime } from '../../../utils/FormateDateTime';
import { useSelector } from 'react-redux';
import { t } from 'i18next';
const ReusableModal = React.lazy(() => import('../../../shared/ReuseableModal'));

const ViewVisitFormEntries = () => {
  const { selectedVisitData } = useSelector(state => state?.visits);
  const selectedPatientData = useSelector(state => state?.beneficiary?.seletedPatientData);
  const { data, loading, executeFetch } = useFetchData();
  const [selectedFormData, setSelectedFormData] = useState(null);
  const [openViewFormDataModal, setOpenViewFormDataModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const actionsColumn = {
    body: actionsTemplate,
    header: t('Actions'),
    headerCellClass: 'flex items-center justify-center'
  };

  const columnsData = [viewFormEntriesTableColumns(t), actionsColumn, ...viewFormEntriesTableColumns(t)];

  function actionsTemplate(rowData) {
    return (
      <div className='flex items-center justify-center gap-1'>
        <EyeIcon
          onClick={() => {
            setSelectedFormData(rowData?.formData);
            setOpenViewFormDataModal(true);
          }}
        />
      </div>
    );
  }

  const fetchInitialData = async () => {
    await executeFetch('GET', labModuleApi.visitResults.getAll(selectedVisitData?.visit_id));
  };

  useEffect(() => {
    fetchInitialData();
  }, [executeFetch]);

  useEffect(() => {
    if (data?.data?.length) {
      let tableRows = data?.data?.map(data => {
        let rowData = {
          created_at: formatDateTime(selectedVisitData?.visit_date),
          full_name: selectedPatientData?.full_name,
          beneficiary_type: selectedPatientData?.beneficiary_type,
          file_no: selectedPatientData?.file_no,
          nationality: selectedPatientData?.nationality,
          formData: data
        };
        return rowData;
      });
      setTableData(tableRows);
    }
  }, [data]);

  return (
    <div className='w-full h-full'>
      <CustomTable isLoading={loading} data={tableData} columns={columnsData} />
      <ReusableModal
        className='w-full md:w-[650px] lg:w-[800px] xl:w-[900px]'
        isVisible={openViewFormDataModal}
        position='top'
        title={'General Form Results'}
        HeaderIcon={FaInfoCircle}
        onClose={() => {
          setOpenViewFormDataModal(false);
          setSelectedFormData(null);
        }}
      >
        <FormsResultsPreviewTable selectedPatientFormData={selectedFormData} />
      </ReusableModal>
    </div>
  );
};

export default ViewVisitFormEntries;
